var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavNotif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#898e9a;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.268,14a4.9,4.9,0,0,0-4.9,4.9v3.367a1.554,1.554,0,0,0,.2,3.1h9.4a1.554,1.554,0,0,0,.2-3.1V18.9A4.9,4.9,0,0,0,24.268,14ZM22.7,25.949v.588a1.567,1.567,0,0,0,3.134,0v-.588Z",
    transform: "translate(-16 -13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavNotif);
export default __webpack_public_path__ + "static/media/nav-notif.242d389c674d3abfc138acdd9375eaf2.svg";
export { ForwardRef as ReactComponent };